import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock'

export default () => {
  const buttons = document.querySelectorAll('.js-toggle-mobile-cover')
  const closeButtons = document.querySelectorAll('.js-close-mobile-cover')
  const cover = document.querySelector('.js-mobile-cover')
  const childCovers = document.querySelectorAll('.js-mobile-child-cover')
  const coverContainer = document.querySelector('.js-mobile-cover-container')
  const childTriggers = document.querySelectorAll('.js-mobile-cover-trigger')
  const childClosers = document.querySelectorAll('.js-mobile-cover-close-child')
  const header = document.querySelector('.c-mobile-sticky-header')

  if (!buttons || !cover || !coverContainer) return
  if (header.classList.contains('active')) cover.classList.add('sticky-header')
  ;[...buttons].forEach(button => {
    button.addEventListener('click', e => {
      if (!document.body.classList.contains('child-active')) {
        if (document.body.classList.contains('menu-open')) {
          console.log('Menu open')
          ;[...childCovers].forEach(childCover => {
            childCover.classList.remove('active')
            childCover.classList.remove('active-sticky')
            clearAllBodyScrollLocks()
          })

          cover.classList.remove('active')
          document.body.classList.remove('menu-open')

          if (header.classList.contains('active')) {
            cover.classList.remove('active-sticky')
          }

          clearAllBodyScrollLocks()
        } else {
          cover.classList.add('active')
          document.body.classList.add('menu-open')
          disableBodyScroll(coverContainer)

          if (header.classList.contains('active')) {
            cover.classList.add('active-sticky')
          }
        }
      } else {
        console.log('Child active')
        cover.classList.remove('active')
        document.body.classList.remove('menu-open')
        document.body.classList.remove('child-active')

        if (header.classList.contains('active')) {
          cover.classList.remove('active-sticky')
        }

        ;[...childCovers].forEach(childCover => {
          childCover.classList.remove('active')
          childCover.classList.remove('active-sticky')
          clearAllBodyScrollLocks()
        })

        clearAllBodyScrollLocks()
      }
    })
  })
  ;[...closeButtons].forEach(button => {
    button.addEventListener('click', e => {
      cover.classList.remove('active')
      cover.classList.remove('active-sticky')

      // Also close every active child
      ;[...childCovers].forEach(childCover => {
        childCover.classList.remove('active')
        childCover.classList.remove('active-sticky')
        clearAllBodyScrollLocks()
      })

      // If active, disable scrolling for everything but coverContainer
      if (cover.classList.contains('active')) {
        disableBodyScroll(coverContainer)
      } else {
        clearAllBodyScrollLocks()
      }
    })
  })
  ;[...childTriggers].forEach(childTrigger => {
    childTrigger.addEventListener('click', e => {
      const childCover = document.getElementById(childTrigger.dataset.target)
      const childContainer = childCover.querySelector(
        '.js-mobile-child-cover-container'
      )
      // Enable body scroll on default cover again
      clearAllBodyScrollLocks()

      // Set child cover as active
      childCover.classList.add('active')
      document.body.classList.add('child-active')

      // Disable body scroll for every element but the cover
      disableBodyScroll(childContainer)

      // Remove active class from parent
      cover.classList.remove('active')
    })
  })
  ;[...childClosers].forEach(childCloser => {
    childCloser.addEventListener('click', e => {
      const childCover = document.getElementById(childCloser.dataset.target)

      childCover.classList.remove('active')

      clearAllBodyScrollLocks()

      disableBodyScroll(coverContainer)

      cover.classList.add('active')
    })
  })

  // Close mobile cover if click outside coverContainer
  cover.addEventListener('click', e => {
    if (!e.target.closest('.js-mobile-cover-container')) {
      cover.classList.remove('active')
      cover.classList.remove('active-sticky')
      document.body.classList.remove('menu-open')
      clearAllBodyScrollLocks()
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/NavMobile.js